module.exports = __webpack_public_path__ + "img/hublot.824c20a3.png";